import Modal from '@mui/material/Modal'
import React from 'react'

interface ICopyMessageModalProps {
  showCopyModal: boolean;
  onClose: () => void;
}

export const CopyMessageModal = (props: ICopyMessageModalProps) => {
  const { showCopyModal = false, onClose } = props
  return (
    <Modal
      open={showCopyModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="success-copy-modal"
    >
      <div className="message-copy-success-box">
        <div className="message-copy-success">
          <span>
            Copied to your clipboard! Now paste your link in a Snapchat message,
          </span>
          <span>your Instagram bio, Whatsapp, Facebook or a text :)</span>
        </div>
        <div className="footer">
          <button className="footer-button" type="button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  )
}
